import React from 'react';

const ExampleCarouselImage = ({ imageSrc, altText }) => (
  <img
    src={imageSrc}
    alt={altText}
    style={{ width: '100%', height: '', objectFit: 'cover' }}
  />
);

export default ExampleCarouselImage;
